import {html} from 'lit';
import {IconData} from '../../utils/icon-data';
export interface wOption {
  label: string;
  value?: any;
}
export type WOptionOrString = wOption | string;

class HelperService {
  constructor() {}

  /**
   *
   * @param isAvailable
   * @param name
   * @param className
   * @returns
   */
  createSlots(isAvailable: boolean, name: string, className: string) {
    return isAvailable
      ? html`<div class=${className}>
          <slot name=${name}></slot>
        </div>`
      : null;
  }

  /**
   * @param icon
   * @param circleColor
   * @returns svg icon
   */
  addSVG(icon: string, circleColor?: string): string {
    // inject standard attributes + class
    const i = ((IconData[icon] as string) || '').replace(
      '<svg ',
      '<svg aria-hidden="true" class="b-icon--as-char" focusable="false" role="img" '
    );
    // if circle element present and we hv defined a fill color
    return circleColor
      ? i.replace('<circle ', `<circle fill="${circleColor}" `)
      : i;
  }

  getOptionValue = (option: WOptionOrString): any => {
    return !option || typeof option === 'string' ? option : option.value;
  };

  /**
   * @param eventName (i.e. keyup)
   * @param self (component reference)
   * @param data (attach custom data in the detail property) : optional
   */
  addEvents(eventName: string, self, data?: unknown) {
    try {
      const prop = {
        bubbles: true,
        composed: true,
      };
      data ? (prop['detail'] = data) : null;
      const event = new CustomEvent(eventName, prop);
      self.dispatchEvent(event);
    } catch (ex) {
      console.log('addEvents-errorlog', ex);
    }
  }
}

export const helperService = new HelperService();
